import { Directive, ElementRef, Input, Output, EventEmitter, HostListener } from '@angular/core';

/**
 * Allows to react on click outside of the given element.
 *
 * USAGE: <div ssfOutsideClick (outsideClick)="foo()" [exceptionIds]="['id1', 'id2']">
 *
 * based on https://christianliebel.com/2016/05/angular-2-a-simple-click-outside-directive/
 */
@Directive({
    selector: '[ssfOutsideClick]'
})
export class OutsideClickDirective {
    /**
     * IDs of HTML elements, that are not strictly inside the parrent element, but should NOT trigger the directive.
     * This is convenient, when there are absolutely positioned elements, which are semantically inside the element,
     * but HTML doesn't reflect that. Use this input over exceptionTags, if possible.
     */
    @Input() exceptionIds: string[];
    /**
     * Names of HTML elements, that are not strictly inside the parrent element, but nor the elements themselves or their children
     * should trigger the directive. If possible, avoid using this input and use exceptionIds instead, because ids are
     * exact at all times, using tags can lead to incorrect behaviour when working with more complex HTML trees.
     */
    @Input() exceptionTags: string[];
    /**
     * What to do on clicking outside the element and its children. Most used for hiding the element.
     */
    @Output() outsideClick = new EventEmitter();

    @HostListener('document:click', ['$event.target'])
    public onClick(targetElement: Element) {
        const clickedInside = this._elementRef.nativeElement.contains(targetElement);
        let exceptionOccured = false;
        let elem: Element = targetElement;
        if (this.exceptionTags || this.exceptionIds) {
            /* navigate through tree structure to root and check whether clicked element is child of any element,
               which is considered exceptional and should not trigger outsideClick */
            while (elem) {
                if ((this.exceptionTags && this.exceptionTags.indexOf(elem.className) !== -1)
                    || (this.exceptionIds && elem.id && this.exceptionIds.indexOf(elem.id) !== -1)) {
                    exceptionOccured = true;
                    break;
                }
                elem = elem.parentElement;
            }
        }
        if (!clickedInside && !exceptionOccured) {
            this.outsideClick.emit(null);
        }
    }

    constructor(private _elementRef: ElementRef) {}
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/modules/shared/directives/outside-click/outside-click.directive.ts